import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import { AlarmJournalList } from '../features/Alarm/AlarmJournal'
import { useIntl, FormattedMessage } from 'react-intl';

const AlarmJournal = () => {
    const intl = useIntl();

    return (
        <Page
        header={intl.formatMessage({ id: "Pages.AlarmJournal.header", defaultMessage: "Alarm Journal" })}
            subheader={intl.formatMessage({ id: "Pages.AlarmJournal.subheader", defaultMessage: "see all alarms that happend" })}
          >
            <AlarmJournalList></AlarmJournalList>
        </Page >
    )
}


export default withAITracking(reactPlugin, AlarmJournal);